const participants = {
	title: "Elever",
	stitle: "Elev",
	new_participant: "Ny deltager",
	edit_participant: "Rediger elev: {name}",
	view_participant: "Vis elev: {name}",
	list_title: "Liste over elever",
	list_subtitle: "Endre elev",
	create_title: "Opprett ny elev",
	update_title: "Oppdater elev",
	address_title: "Adresse",
	details_title: "Deltager informasjon",
	id: "ID",
	pid: "Personnummer",
	company_id: "Bedrift",
	name: "Navn",
	first_name: "Fornavn",
	middle_name: "Mellomnavn",
	last_name: "Etternavn",
	email: "Epost",
	mobile: "Mobil",
	birthday: "Fødselsdag",
	date_of_birth: "Født",
	street: "Adresse",
	city: "By/Sted",
	state: "Fylke",
	zip: "Postnr",
	country: "Land",
	employeed_from: "Ansatt fra",
	comments: "Notat",
	created_by: "Opprettet av",
	employees: "Ansatte",
	select_employees: "Select employees",
	type: "Type",
	merge: "Slå sammen",
	verify_image: "Verifiser bilde",
	not_verified: "Ikke bekreftet",
	merge_title: "Slå sammen deltagere",
	merge_sub: "Velg deltagere som skal sammenslåss",
	no_participant_selected: "Velg elev",
	merge_success: "Deltagere slått sammen",
	merge_failed: "Sammenslåing av deltagere feilet",
	merge_confirm: "Valgte deltagere vil bli slått sammen. Denne handlingen kan ikke angres?",
	sync: "Synk",
	unique_id: "ID",
	documents: "Interne dokumenter",
	add_documents: "Legg til",
	upload_documents: "Last opp",
	select_documents: "Velg",
	student_group_id: "Elevgruppe",
	certreguser_exist_confirm: "Bruker med <br/><br/> navn: {name} <br/> epost: {email} <br/> mobil: {mobile} er allerede registrert. Vil du legge brukeren som deltager?",
	update_document: "Oppdater dokument",
	students_documents: "Elevdokumenter",
	cannot_delete_has_enrolment_attendee: "Eleven er påmeldt eller er deltager på et kurs. Vennligst fjern påmelding eller vent til kurs er gjennomført før elev kan slettes.",
	age_below_18: "Personer under 18 år kan ikke utføre arbeid som medfører fare for liv eller helse. Forskrift om administrative ordninger §12-6 Selv om personen har fått og bestått opplæring som beskrevet under, kan ikke personer under 18 år, settes til selvstendig arbeid som kan medføre fare for live eller helse. Denne type arbeid kan bare gjennomføres som del av yrkesrettet opplærings, iht. unntak fra arbeidsforbud, Forskrift om organisering og ledelse §12-7",
	merge_to_existing: "Slå sammen med eksisterende elev",
	merge_existing_participant: "Eksisterende elev",
	merge_new_participant: "Ny elev",
	pid_exists_confirm: "Elev med dette personnummeret er allerede registrert I XL3. Vil du hente persondata?",
	show_deleted_documents: "Papirkurv",
	show_documents: "Tilbake",
	deleted_documents: "(I papirkurv)",
	internal_notes: "Interne notater",
	in_add_note: "Nytt notat",
	in_new_title: "Nytt intern notat",
	in_update_title: "Rediger",
	in_note: "Intern notat",
	employee_number: "Ansattnummer",
};
export default participants;